// @ts-check
// Comandos da retenção na ficha da família (contrato 10 de atendimento, seção 25): "Marcar risco de evasão" e "Abrir caso
// de retenção". O registro é da fundação (client/src/lib/command-registry.js): um comando só aparece quando o id está em
// RETENTION_COMMAND_IDS, o módulo está ligado e o papel tem SERVICE_DESK. A execução abre os mesmos diálogos da seção
// da família, que hospeda o diálogo.
import { getRecordLabel } from '../../lib/field-metadata.js';
import { t } from '../../i18n/index.js';
import { openRetentionDialog } from './retention-dialogs.js';

/**
 * Comandos da retenção já prontos para aparecer.
 * @type {ReadonlySet<string>}
 */
export const RETENTION_COMMAND_IDS = new Set(['record.markRetentionRisk', 'record.openRetentionCase']);

/**
 * Executa um comando da retenção. Devolve false quando o comando não é da retenção.
 * @param {import('../../lib/command-registry.js').CommandDescriptor} command
 * @param {import('../command-menu/command-actions.js').CommandRuntime} runtime
 * @returns {Promise<boolean>}
 */
export async function runRetentionCommand(command, runtime) {
  if (!RETENTION_COMMAND_IDS.has(command.id)) return false;
  const target = runtime.record;
  if (!target?.record || target.objectMetadata.nameSingular !== 'household') return true;
  const householdId = String(target.record.id);
  const householdName = getRecordLabel(target.objectMetadata, target.record) || t('record.untitled');
  const onDone = () => target.reload();
  if (command.id === 'record.markRetentionRisk') openRetentionDialog({ kind: 'mark', householdId, householdName, onDone });
  else openRetentionDialog({ kind: 'open', householdId, householdName, onDone });
  return true;
}
